import CourseraPlusProductVariant from 'bundles/coursera-plus-common/constants/CourseraPlusProductVariant';
import ProductTypeObject from 'bundles/payments-common/common/ProductType';

export type CourseraPlusProduct = {
  productType: string;
  productItemId: string;
};

export const isCourseraPlusAnnualNoFreeTrialProduct = ({ productType, productItemId }: CourseraPlusProduct): boolean =>
  productType === ProductTypeObject.COURSERA_PLUS_SUBSCRIPTION &&
  productItemId === CourseraPlusProductVariant.ANNUAL_NO_FREE_TRIAL;
